import { AMBER, DANGER, SUCCESS } from "../constants";

export function GaugeRing({ pct }) {
  const color = pct >= 90 ? SUCCESS : pct >= 75 ? AMBER : DANGER;
  const deg = Math.min(pct, 100) * 3.6;
  return (
    <div
      style={{
        width: 48, height: 48, borderRadius: "50%", flexShrink: 0,
        background: `conic-gradient(${color} ${deg}deg, #e4e9f2 ${deg}deg)`,
        display: "flex", alignItems: "center", justifyContent: "center",
      }}
    >
      <div
        style={{
          width: 34, height: 34, borderRadius: "50%", background: "#fff",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}
      >
        <span style={{ fontSize: 9, fontWeight: 900, color, lineHeight: 1 }}>
          {pct.toFixed(0)}%
        </span>
      </div>
    </div>
  );
}
